import { Join } from 'design-studio/lib'
import { GlassCard } from 'design-studio'
import { DiagramCostOfInference } from '@/components/diagrams/diagram-cost-of-inference'
import { DiagramReasoningCorrectness } from '@/components/diagrams/diagram-reasoning-correctness'

interface DiagramTwinCubeCornerProps {
  className?: string
}

export function DiagramTwinCubeCorner({
  className,
}: DiagramTwinCubeCornerProps) {
  return (
    <div className={Join('flex flex-col gap-3 px-6', className)}>
      <GlassCard className="aspect-video overflow-hidden border-transparent sm:p-0 dark:border-transparent">
        <DiagramCostOfInference className="h-full w-full" />
      </GlassCard>
      <GlassCard className="aspect-video overflow-hidden border-transparent sm:p-0 dark:border-transparent">
        <DiagramReasoningCorrectness className="h-full w-full" />
      </GlassCard>
    </div>
  )
}
